import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 8 13" {...props}>
      <title>{props.title || 'Chevron Right'}</title>
      <g fill="none" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g
          transform="translate(-2.000000, 4.000000)"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline
            transform="translate(5.500000, 2.500000) rotate(90.000000) translate(-5.500000, -2.500000)"
            points="10.5 5 5.5 6.66133815e-16 0.5 5"
          />
        </g>
      </g>
    </Icon>
  )
}
